import * as React from 'react';

function SvgAccountStroke1(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.302 15.97c-.83-.747-1.46-1.737-1.746-2.618a1.213 1.213 0 01-.421-.44c-.648-1.144-.591-2.088.004-2.701l.066-.065a7.485 7.485 0 01.246-1.862c.114-.405.391-.96.905-1.51.845-.905 2.055-1.445 3.647-1.445 1.592 0 2.802.54 3.647 1.444.514.55.791 1.106.906 1.513l.05.192c.135.562.19 1.133.195 1.646.013.01.026.022.039.035.622.58.674 1.534.023 2.748a1.261 1.261 0 01-.416.46c-.313.9-.939 1.872-1.751 2.605.061.045.146.104.253.174.308.2.67.4 1.086.589.224.101.457.196.7.284 2.657.958 3.858 3.059 4.062 6.263.064 1.001-.767 1.96-1.788 1.96H7.99c-1.032 0-1.848-.972-1.787-1.985.2-3.213 1.377-5.204 4.064-6.174.268-.096.522-.203.763-.32.383-.183.712-.378.986-.572.145-.102.24-.18.286-.22zm1.13.781a.694.694 0 01-.169.238c-.297.275-.842.66-1.626 1.037a9.517 9.517 0 01-.895.374c-2.097.757-2.974 2.24-3.141 4.943-.015.241.202.5.39.5h14.018c.186 0 .405-.252.39-.471-.171-2.701-1.082-4.294-3.14-5.036-.277-.1-.545-.21-.803-.327-.828-.375-1.416-.757-1.742-1.026a.697.697 0 01-.175-.215 3.494 3.494 0 01-1.536.375 3.52 3.52 0 01-1.572-.392zm-2.072-4.548c.208.127.348.258.48.574.38 1.26 1.826 2.966 3.163 2.966 1.336 0 2.78-1.704 3.157-2.94.067-.26.21-.41.409-.538l.074-.045c.215-.407.296-.705.285-.9-.005-.084-.02-.116-.044-.138l-.002-.002c-.007-.007-.009-.008.017 0a.7.7 0 01-.503-.713v-.001l.002-.051a6.291 6.291 0 00-.19-1.751c-.058-.207-.239-.569-.581-.935-.583-.624-1.426-1-2.624-1-1.199 0-2.04.376-2.624 1-.342.366-.522.728-.58.932a6.292 6.292 0 00-.19 1.754l.001.05v.002a.7.7 0 01-.445.693c.012-.005.01-.002 0 .006a.401.401 0 00-.021.02c-.131.135-.149.393.189 1l.027.017z"
        fill="#414B56"
      />
    </svg>
  );
}

export default SvgAccountStroke1;
